import { createSlice } from '@reduxjs/toolkit'

export const RightModelStatus = createSlice({
  name: 'right_model_status',

  initialState: {
    value: {}
  },
  reducers: {
    updateRightModelStatus: (state, action) => {
        if(action.payload.type){
            return { ...state,
                value:{
                  ...state.value,[action.payload.type]: action.payload.value
                }              
            }
        } else {
            state.value = action.payload
        }     
    }
  }
})

export const { updateRightModelStatus } = RightModelStatus.actions

export default RightModelStatus.reducer